import React from 'react';
import { FieldArray, getIn } from 'formik';

import styles from './addRemoveFormStyles';

import AddRemoveButton from 'buyside/components/presentation/AddRemoveButton/addRemoveButton';

const AddRemoveForm = ({
  title,
  attr,
  renderItem,
  itemName,
  blankItem,
  cannotRemoveFirstItem,
  lockExisting,
  isSumzeroAdmin
}) => {
  const renderFieldArray = ({ push, remove, form: { values, isSubmitting } }) => {
    const items = getIn(values, attr);
    const handleAdd = () => {
      push(Object.assign({}, blankItem));
      const lastItemPath = `${attr}[${items.length}]`;
      setTimeout(() => {
        const lastItem = document.getElementById(lastItemPath);
        lastItem.scrollIntoView({ behavior: 'smooth' });
        const input = lastItem.getElementsByTagName('input')[0];
        if (input) input.focus();
      });
    };
    return (
      <div className={styles.addRemoveForm}>
        <div>
          {title && <h4 className={styles.addRemoveFormTitle}>{title}</h4>}
          {(items || []).map((item, idx) => {
            const itemPath = `${attr}[${idx}]`;
            const onlyAdminRemove = item.id && lockExisting;
            return (
              <div id={itemPath} key={idx} className={styles.addRemoveFormItem}>
                {renderItem(itemPath, item, idx)}
                {(idx !== 0 || !cannotRemoveFirstItem) && (!onlyAdminRemove || isSumzeroAdmin) && (
                  <div className={styles.addRemoveFormRemoveButton}>
                    <AddRemoveButton
                      type="remove"
                      text={`Remove This ${itemName}${onlyAdminRemove ? ' (Admin Only)' : ''}`}
                      onClick={() => remove(idx)}
                      disabled={isSubmitting}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className={styles.addRemoveFormAddButton}>
          <AddRemoveButton
            type="add"
            text={`Add ${itemName}`}
            onClick={handleAdd}
            disabled={isSubmitting}
          />
        </div>
      </div>
    );
  };
  return <FieldArray name={attr} render={renderFieldArray} />;
};

export default AddRemoveForm;
